/**
 * Layout size constants
 */

export const SIDEBAR_DESKTOP_WIDTH = 180;

export const SIDEBAR_MOBILE_WIDTH = 240;

export const USER_SUGGESTIONS_WIDTH = 240;

export const HEADER_HEIGHT = 60;
